import { render, staticRenderFns } from "./AbsencePlanDetailsTable.vue?vue&type=template&id=2280262a&"
import script from "./AbsencePlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./AbsencePlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports